/*AI助理相关
i:get || post
h:requestGet ||requestPost
*/
import axios from '../axios'
export default {
    // 获取AI助理信息
    assistantDetails: () => axios.get('/api/tools/ai/assistant/info'),
    //历史记录
    chatHistory: (chat_id,page,app_id) => axios.get(`/api/tools/ai/library/chat/history?chat_id=${chat_id}&limit=10&page=${page}&app_id=${app_id}`),
    //清除历史记录 delete 请求
    clearHistory: (data) => axios.iDelete(`/api/tools/ai/library/chat/history`, data), 
    // 猜你想问
    guessYouApi: (data) => axios.get(`/api/tools/ai/library/chat/guide`, data),
}